import React, { useEffect, useState } from 'react'
import { Form, Button, Select ,Modal } from 'antd';
import { renderInput, renderSelect } from '../../../component/form/form';
import { userHelper, packageHelper } from "../../../actions/package";
import { connect } from 'react-redux';
import { createUser } from "../../../actions/appUser";
const { Option } = Select;
const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
  };
  const tailLayout = {
    wrapperCol: { offset: 4, span: 16 },
  };

  const status = [
    {value: true, label: 'Active'},
    {value: false, label: 'Inactive'},
  ]
  

  
const ModalForm = ({visible, setVisible, createUser, refresh, userHelper, packageHelper }) => {
    
  const [packageData, setPackageData] = useState([]);
  const [user, setUser] = useState([]);
  const [form] = Form.useForm();
  
  const getData = async () => {
    const usr = await userHelper();
    setUser(usr);
    const pkg = await packageHelper();
    setPackageData(pkg);
  }

  const createoption = (value, label) => {
    return {value, label};
  };

  const packageOption = [
    packageData?.map(item => createoption(
      item.value,
      item.name,
    ))
  ]

  const userOption = [
    user?.map(item => createoption(
      (item.user_id).toString(),
      item.name,
    ))
  ]
  useEffect(() => {
    getData()
  }, [])

      const onFinish =async (values) => {
        // console.log('Success:', values);
        const code = await createUser(values)
        if(code === 201){
          refresh()
          setVisible()
          form.resetFields();
        }
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };

    return ( 
          <Modal
          title="Create App User"
          centered
          visible={visible}
          onOk={() => setVisible(false)}
          onCancel={() => setVisible(false)}
          width={1000}
        >
              <Form
                {...layout}
                name="basic"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
              >
            
                {renderInput('app_id', 'App ID', [
                    { required: true, message: 'This field is required!' },
                    { pattern: RegExp('^[0-9]+$'), message: 'Only number acceptable' },
                  ])
                }
                {renderInput('name', 'Location', [
                    { required: true, message: 'This field is required!' },
                  ])
                }
                {renderSelect('package_value', 'Package', [
                    { required: true},
                  ],
                  'Select a option', packageOption[0], 'none')
                }
                {renderSelect('user_id', 'User', [
                    { required: true},
                  ],
                  'Select a option', userOption[0], 'none')
                }
                {renderSelect('status', 'Status', [
                    { required: true},
                  ],
                  'Select a option', status, 'none')
                }
                
                <Form.Item {...tailLayout}> 
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              
              </Form>

        </Modal>
     );
}
 
export default connect(null,{createUser, userHelper, packageHelper})(ModalForm);
